import { useState, useMemo } from 'react'
import { Link, generatePath } from 'react-router-dom'

import { Space, Button } from 'antd'
import * as Icons from '@ant-design/icons'
import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'

import { CompaniesList } from './CompaniesList'
import { CompaniesImport } from './CompaniesImport'
import { CompaniesExport } from './CompaniesExport'

import { CompanyListMergeModal } from './CompanyListMergeModal'

export function Companies() {
  const [showMerge, setShowMerge] = useState(false)
  const [selectedRowIds, setSelectedRowIds] = useState({})
  const selectedRowIdsList = useMemo(() => {
    return Object.keys(selectedRowIds).filter(key => selectedRowIds[key])
  }, [selectedRowIds])

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem href={ROUTES.REFERENCE_DATA.INDEX}>
                    Reference Data
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: 'Companies'
              }
            ]}
          />

          <Space>
            <Button
              type="primary"
              icon={<Icons.ForkOutlined rotate={270} />}
              disabled={selectedRowIdsList.length <= 1}
              onClick={() => setShowMerge(true)}
            >
              Merge {selectedRowIdsList.length} Items
            </Button>
            {showMerge && (
              <CompanyListMergeModal
                open={showMerge}
                onClose={() => setShowMerge(false)}
                companyIds={selectedRowIdsList}
              />
            )}
            <Link to={generatePath(ROUTES.COMPANIES.NEW)}>
              <Button icon={<Icons.FolderAddOutlined />} type="primary">
                New
              </Button>
            </Link>

            <CompaniesImport />

            <CompaniesExport />
          </Space>
        </>
      }
    >
      <CompaniesList
        selectedRowIds={selectedRowIds}
        setSelectedRowIds={setSelectedRowIds}
      />
    </Layout>
  )
}
